/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { customElement } from 'common';
import './index.css';

import Datepicker from './components/pxp-datepicker/pxp-datepicker';
export * from './components/pxp-datepicker/pxp-datepicker';
export { Datepicker };
customElement.register('pxp-datepicker', 'pxp', Datepicker.defaultProps, Datepicker);

import LaunchPad from './components/pxp-launch-pad/pxp-launch-pad';
export * from './components/pxp-launch-pad/pxp-launch-pad';
export { LaunchPad };
customElement.register('pxp-launch-pad', 'pxp', LaunchPad.defaultProps, LaunchPad);

import LunchCounts from './components/pxp-lunch-counts/pxp-lunch-counts';
export * from './components/pxp-lunch-counts/pxp-lunch-counts';
export { LunchCounts };
customElement.register('pxp-lunch-counts', 'pxp', LunchCounts.defaultProps, LunchCounts);

